import React, { useMemo } from 'react';

import { Descriptions, DescriptionsProps, Divider, Image, Modal } from 'antd';

import dayjs from 'dayjs';
import { DATETIME_CLIENT_FORMAT } from 'internal-constants';
import { makeCpf } from 'lib/helpers/Domain.helper';
import { Guest } from 'types/Guest.type';

type Props = {
    guest: Guest.Model,
    onCancel: () => void,
};

export function GuestDetailsModal({ guest, onCancel }: Props) {
    const title = `Detalhes do visitante #${guest.id}`;

    const items: DescriptionsProps['items'] = useMemo(() => {
        return [
            {
                key: 'id',
                label: 'ID',
                children: guest.id,
            },

            {
                key: 'name',
                label: 'Nome',
                children: guest.name,
            },

            {
                key: 'cpf',
                label: 'CPF',
                children: makeCpf(guest.cpf),
            },

            {
                key: 'created_at',
                label: 'Cadastrado em',
                children: dayjs(guest.created_at).format(DATETIME_CLIENT_FORMAT),
            },

            {
                key: 'picture',
                label: 'Foto de perfil',
                span: 'filled',
                children: guest.picture !== null
                    ? <Image src={guest.picture} width={256} />
                    : '-',
            },
        ];
    }, [guest.cpf, guest.created_at, guest.id, guest.name, guest.picture]);

    return (
        <Modal
            open
            width={610}
            title={title}
            onCancel={onCancel}
            footer={null}
        >
            <Divider />

            <Descriptions
                items={items}
                column={2}
                layout="vertical"
                bordered
            />
        </Modal>
    );
}
